export const TIME_OFF_UNAVAILABLE_SUSPENDED_CATEGORIES = [8, 9, 10];
